export default __webpack_public_path__ + "static/media/Newsletter Email Format.a2910ff9.xlsx";